import React from 'react';
import { Row, Col } from 'antd';
import VideoList from './Videos'

const VideosListComponent = () => (
    <div className="container">
         <VideoList />
    </div>
  );
  
  export default VideosListComponent;